module.exports = __webpack_public_path__ + "img/avatar2.7f5c7a59.png";